import { Box, Typography } from "@mui/material";
import StylishSlider from "./components/StylishSlider";

function CheckboxCard({
  checked,
  label,
  disabled,
  selection,
  sliderValue,
  onSliderChange,
}) {
  return (
    <Box
      sx={{
        position: "relative",
        width: "98%",
        height: "135px",
        borderRadius: "12px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        "&:hover": {
          transform: disabled ? "none" : "translateY(-2px)",
          boxShadow: disabled ? "none" : "0 5px 15px rgba(0,0,0,0.1)",
        },
      }}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 12px",
          gap: "8px",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: checked ? 600 : 400,
            color: checked
              ? selection === "Backward"
                ? "#ff8787"
                : "#1976d2"
              : "#333",
            textAlign: "center",
            transition: "all 0.3s ease",
            fontFamily: "Pretendard !important",
          }}
        >
          {label}
        </Typography>
        <StylishSlider
          selection={selection}
          value={sliderValue}
          onChange={onSliderChange}
        />
      </Box>
    </Box>
  );
}

export default CheckboxCard;
